"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- CONTENTTYPE : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'ContentType',
  props: {
    type: {
      type: 'string',
      default: 'quiz',
      options: ['quiz', 'poll', 'story']
    },
    count: {
      type: 'number',
      default: 0
    },
    contentId: {
      type: 'string',
      default: 'a1ab4eb5-e63d-48c3-abd6-84e712deabae'
    },
    indicatorType: {
      type: 'string',
      default: 'noToggling',
      options: ['noToggling', 'sort']
    },
    selectable: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    isLive: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    handleClick: {
      type: 'function',
      default: function _default() {
        return console.log('Clicked');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;